import { useStorage } from '@vueuse/core';
import { MediaType, type Image, type Media, type Video } from './types';

export const imagesMapper = (images?: Image[]): Media[] => {
	return images?.map(({ src }) => ({ type: MediaType.IMAGE, src })) ?? [];
};

export const videosMapper = (
	videos: Video[] | Video[][] | null | undefined,
	fallbackThumbnail?: Image,
): Media[] => {
	if (!videos) return [];

	//to cater both cms response and online store
	const flatVideos = Array.isArray(videos[0])
		? (videos as Video[][]).flat()
		: (videos as Video[]);

	return flatVideos.map((video) => ({
		type: MediaType.VIDEO,
		src: video.hls_url || video.original_url,
		poster: video.thumbnail || fallbackThumbnail?.src,
		content_id: video.content_id ? video.content_id : 0,
	}));
};

export const useMute = () => {
        const storage = typeof window !== 'undefined' ? sessionStorage : undefined;
        const isMuted = useStorage('is-video-muted', true, storage);

        const toggleMute = () => {
                isMuted.value = !isMuted.value;
        };
        const resetMute = () => {
                isMuted.value = true;
                storage?.setItem('is-video-muted', isMuted.value.toString());
        };
        return { isMuted, toggleMute, resetMute };
};
